// Works
export const works_es = [
  {
    title: "Sublima Lashes",
    subtitle: "E-commerce",
    category: "Desarrollo Wordpress",
    tags: ["Wireframes", "Templates", "CSS3", "UI/UX", "WPO", "Landing Page"],
    cover: "./img/projects/sublima--3.webp",
    link: "https://www.sublimalashes.com/",
    class: "full wide",
  },
  {
    title: "Delaviuda",
    subtitle: "E-commerce",
    category: "Desarrollo Wordpress",
    tags: ["Templates", "CSS3", "ACF", "WooCommerce", "SEO", "WPO"],
    cover: "./img/projects/delaviuda.webp",
    link: "https://www.delaviuda.com/",
    class: "square half",
  },
  {
    title: "El Almendro",
    subtitle: "E-commerce",
    category: "Desarrollo Wordpress",
    tags: ["Templates", "CSS3", "ACF", "WooCommerce", "SEO", "WPO"],
    cover: "./img/projects/elalmendro.webp",
    link: "https://www.elalmendro.com/",
    class: "square half",
  },
  {
    title: "PSworks",
    subtitle: "Agencia",
    category: "Desarrollo Wordpress",
    tags: ["JS", "CSS3", "ACF", "CPT UI", "SEO", "WPO"],
    cover: "./img/projects/psworks_02.webp",
    link: "https://www.psworks.es/",
    class: "full wide",
  },
  {
    title: "Socialisssima",
    subtitle: "Agencia",
    category: "Diseño & Desarrollo Wordpress",
    tags: ["JS", "CSS3", "ACF", "CPT UI", "SEO", "WPO"],
    cover: "./img/projects/socialisssima_2024.webp",
    link: "https://socialisssima.com/",
    class: "full wide",
  },
  {
    title: "Pollinators & Prairies",
    subtitle: "Institución",
    category: "Desarrollo Wordpress",
    tags: ["UX", "UI", "PHP", "CSS3", "SEO", "WPO"],
    cover: "./img/projects/pp_texas.webp",
    link: "https://pollinatorsandprairies.org/",
    class: "square half",
    blog_link:
      "https://juanfalibene.com/writing/#/post/id=1369&category=trabajo-cotidiano",
  },
  {
    title: "Amazon FE",
    subtitle: "Consultoría",
    category: "Wordpress UX / UI",
    tags: ["UI", "UX", "Análisis Heurístico"],
    cover: "./img/projects/amazon_fe.webp",
    link: "https://www.amazonfutureengineer.com/",
    blog_link: "https://juanfalibene.com/writing/#/case-study/109",
    class: "square half",
  },
  {
    title: "Irene Pietrella",
    subtitle: "Portfolio",
    category: "Desarrollo Wordpress",
    tags: ["PHP", "JS", "CSS3", "ACF", "Templates", "SEO", "WPO"],
    cover: "./img/projects/irene-pietrella.webp",
    link: "https://irene-pietrella.com/",
    blog_link: "https://juanfalibene.com/writing/#/case-study/84",
    class: "vertical quarter",
  },
  {
    title: "Martina Orska",
    subtitle: "Portfolio",
    category: "Desarrollo Wordpress",
    tags: ["PHP", "ACF", "CPT UI", "JS", "CSS3", "SEO", "WPO"],
    cover: "./img/projects/martina_orska.webp",
    link: "https://martinaorska.com/",
    blog_link: "https://juanfalibene.com/writing/#/case-study/831",
    class: "vertical quarter",
  },
  {
    title: "Rocio Ley",
    subtitle: "Portfolio",
    category: "Desarrollo Wordpress",
    tags: ["ACF", "JS", "CSS3", "CPT UI", "SEO", "WPO"],
    cover: "./img/projects/03_smoda.webp",
    link: "https://rocioley.com",
    class: "vertical quarter",
    blog_link: "https://juanfalibene.com/writing/#/case-study/11",
  },
];

// Projects
export const projects_es = [
  {
    title: "Discava!",
    subtitle: "APP Búsqueda Vinilos",
    category: "Desarrollo Front-End",
    tags: [
      "HTML5",
      "CSS3",
      "JS Vanilla",
      "Discogs API",
      "Youtube Playlist",
      "Local Storage",
    ],
    cover: "./img/projects/discava-v2.webp",
    link: "http://dev.juanfalibene.com/discava/index.html",
    github_link: "https://github.com/juanfalibene/discava-digital",
    blog_link:
      "https://juanfalibene.com/writing/#/post/id=1943&category=idea-de-proyecto",
    class: "full wide",
  },
  {
    title: "CaliTrack",
    subtitle: "App de IA",
    category: "AI vibe coding",
    tags: ["React.js", "CSS3", "JS Vanilla", "HTML5"],
    cover: "./img/projects/calitrack_mobile.webp",
    link: "https://jf-calitrack.lovable.app/",
    blog_link:
      "https://juanfalibene.com/writing/#/post/id=1909&category=idea-de-proyecto",
    class: "half square",
  },
  {
    title: "Juan Falibene Writing",
    subtitle: "WP Headless",
    category: "Desarrollo Front-End & Wordpress",
    tags: [
      "WP REST API",
      "JWT Auth",
      "ACF",
      "CPT UI",
      "React.js",
      "CSS3",
      "HTML5",
      "SEO",
    ],
    cover: "./img/projects/project_blog_writing.webp",
    link: "https://juanfalibene.com/writing",
    class: "half square",
    blog_link:
      "https://juanfalibene.com/writing/#/post/id=28&category=idea-de-proyecto",
  },
  {
    title: "Daily News",
    subtitle: "React Web APP",
    category: "Desarrollo Front-End",
    tags: [
      "React",
      "Redux",
      "Google API",
      "G News API",
      "Axios",
      "Material UI",
    ],
    cover: "./img/projects/daily-news-app-g.webp",
    link: "https://dev.juanfalibene.com/daily-news",
    github_link: "https://github.com/juanfalibene/daily-news",
    class: "half wide",
  },
  {
    title: "Dev Tree",
    subtitle: "Tema de WP",
    category: "Desarrollo Wordpress",
    tags: [
      "PHP",
      "CMS",
      "ACF",
      "CPT UI",
      "Templates",
      "CSS3",
      "HTML5",
      "JS Vanilla",
      "Antigravity",
      "AI",
      "GitHub Actions",
      "Python",
    ],
    cover: "./img/projects/project-wp-theme-dev.webp",
    link: "https://links.juanfalibene.com/dev-tree/",
    class: "half square",
    github_link: "https://github.com/juanfalibene/web-dev-tree",
    blog_link:
      "https://juanfalibene.com/writing/#/post/id=235&category=idea-de-proyecto",
  },
  {
    title: "Music Portfolio",
    subtitle: "Navegación",
    category: "Desarrollo Front-End",
    tags: ["React", "React Router", "React Hooks"],
    cover: "./img/projects/project02.webp",
    link: "https://music.juanfalibene.com/",
    github_link: "https://github.com/juanfalibene/react-music-portfolio",
    class: "half square",
  },
  {
    title: "Proyectos Simples",
    subtitle: "Colección",
    category: "Desarrollo Front-End",
    tags: ["JS Vanilla", "React", "CSS3", "HTML5"],
    cover: "./img/projects/song_of_the_day_app.webp",
    link: "https://juanfalibene.com/writing/#/challenges",
    github_link: "https://github.com/juanfalibene/",
    class: "half square",
  },
];

// Clients
export const clients_es = [
  {
    name: "Pablo Martinez Herrera",
    link: "https://www.linkedin.com/in/pablo-mart%C3%ADnez-herrera-93529345/",
    since: 2019,
  },
  {
    name: "Socialisssima",
    link: "https://socialisssima.com",
    since: 2020,
  },
  {
    name: "PS Works",
    link: "https://psworks.es",
    since: 2022,
  },
  {
    name: "Partida Continua",
    link: "https://partidacontinua.com/",
    since: 2023,
  },
];

export const hard_skills_es = [
  {
    skill: "HTML5",
    image: "./img/skills/html-5.svg",
  },
  {
    skill: "CCS3",
    image: "./img/skills/css-3.svg",
  },
  {
    skill: "JS",
    image: "./img/skills/js.svg",
  },
  {
    skill: "React",
    image: "./img/skills/react.svg",
  },
  {
    skill: "Wordpress",
    image: "./img/skills/wordpress.svg",
  },
  {
    skill: "PHP",
    image: "./img/skills/php_02.svg",
  },
  {
    skill: "Python",
    image: "./img/skills/python.svg",
  },
  {
    skill: "Github",
    image: "./img/skills/github-mark-white.svg",
  },
];

export const soft_skills_es = [
  {
    skill: "Resolución de Problemas",
  },
  {
    skill: "Creatividad",
  },
  {
    skill: "Comunicación Efectiva",
  },
  {
    skill: "Orientación al Detalle",
  },
  {
    skill: "Trabajo en Equipo",
  },
  {
    skill: "Gestión del Tiempo",
  },
];

// About
export const about_es = [
  {
    name: "Juan Falibene",
    text: "Basado en Barcelona",
    profession: "Desarrollador Wordpress & Front-End",
    image: "./img/juanfalibene_profile_hover.jpg",
    imagePic: "./img/juanfalibene_profilepic_06_2025.webp",
    resume_page: "./resume/index.html",
    bio_excerpt:
      "Soy un Desarrollador WordPress y Front-End apasionado por crear experiencias digitales a medida. Me especializo en transformar conceptos iniciales en soluciones completamente funcionales enfocadas en el usuario, combinando un diseño intuitivo con precisión técnica para entregar proyectos de alta calidad.",
    bio_values:
      "Creo en la innovación, eficiencia y atención al detalle, creando soluciones web que son confiables, escalables y alineadas con las necesidades de cada cliente. Mi objetivo es entregar experiencias digitales funcionales y bien construidas que aporten valor e impulsen resultados significativos.",
    bio: "Mi <a href='https://juanfalibene.com/writing/#/post/id=522&category=historia' target='_blank' rel='noopener noreferrer'>trayectoria</a> ha sido moldeada por una combinación de educación formal y experiencia autodidacta, creciendo junto a agencias y clientes individuales. Disfruto colaborando a lo largo de todo el proceso, asegurando que cada proyecto equilibre creatividad, rendimiento y objetivos específicos del cliente.",
  },
];

// Sections
export const section_description_es = [
  {
    section: "Trabajos",
    description:
      "Durante los últimos 6 años, me he especializado en diseñar y desarrollar sitios web en WordPress para agencias y clientes particulares. Ofrezco soluciones completas, que incluyen diseño, desarrollo, soporte y transferencia de conocimientos para garantizar el éxito de cada proyecto.",
  },
  {
    section: "Servicios",
    description:
      "SOCIO TECNOLÓGICO INTEGRAL. No solo construimos, integramos. D*IDEA fue creada para equipos que buscan más que un proveedor porque necesitan un verdadero motor de crecimiento. Definamos tu visión y hagámosla realidad juntos. Explora nuestros servicios y descubre cómo podemos ayudar a que tu proyecto evolucione.",
  },
  {
    section: "Blog",
    description:
      "Te invito a explorar mi <a href='https://juanfalibene.com/writing/' target='_blank' rel='noopener noreferrer'>blog</a>, donde comparto más sobre mi trayectoria y amplío los detalles de mi trabajo. Encontrarás información sobre mis últimos proyectos, reflexiones sobre desarrollo web y un archivo con todos mis trabajos.",
  },
  {
    section: "Proyectos",
    description:
      "Estos proyectos forman parte de mi aprendizaje continuo para dominar las tecnologías front-end. A través de ellos, demuestro mi compromiso por seguir desarrollando nuevas habilidades y conocimientos en este campo.",
  },
];

// Blog Links
export const blog_links_es = [
  {
    title:
      "Discava! 2.0 - Una APP de Búsqueda de Vinilos con Integración de API",
    link: "https://juanfalibene.com/writing/#/post/id=1943&category=idea-de-proyecto",
  },
  {
    title: "Desarrollando un Bot de Wordpress para Creación de Contenido",
    link: "https://juanfalibene.com/writing/#/post/id=1923&category=idea-de-proyecto",
  },
  {
    title: "Actualizar un proyecto personal con Antigravity",
    link: "https://juanfalibene.com/writing/#/post/id=1890&category=nota",
  },
  {
    title: "Test de Vibe Coding con Lovable App: Calitrack",
    link: "https://juanfalibene.com/writing/#/post/id=1909&category=idea-de-proyecto",
  },
  {
    title: "CV Web 2025",
    link: "https://juanfalibene.com/writing/#/post/id=1824&category=historia",
  },
  {
    title: "Wireframes: de la idea al diseño implementado",
    link: "https://juanfalibene.com/writing/#/post/id=1369&category=trabajo-cotidiano",
  },
  /*{
    title: "Autocompletado con IA de Windsurf",
    link: "https://juanfalibene.com/writing/#/post/id=837&category=nota",
  },
  {
    title: "Explorando Python y Automatización",
    link: "https://juanfalibene.com/writing/#/post/id=776&category=reflexion",
  },*/
  {
    title: "Probando GPT o3-mini-high",
    link: "https://juanfalibene.com/writing/#/post/id=756&category=nota",
  },
  {
    title: "Día a día: Proyecto con ChatGPT",
    link: "https://juanfalibene.com/writing/#/post/id=752&category=idea-de-proyecto",
  },
  {
    title: "Introducción a WP Headless",
    link: "https://juanfalibene.com/writing/#/post/id=28&category=idea-de-proyecto",
  },
];

// About Links
export const about_links_es = [
  {
    name: "Linkedin",
    link: "https://www.linkedin.com/in/juanfalibene/",
    category: "professional",
  },
  {
    name: "GitHub",
    link: "https://github.com/juanfalibene",
    category: "professional",
  },
  {
    name: "Blog",
    link: "https://juanfalibene.com/writing/",
    category: "personal",
  },
  {
    name: "Música",
    link: "https://music.juanfalibene.com",
    category: "personal",
  },
  {
    name: "Dev & UX/UI Resources",
    link: "https://links.juanfalibene.com/dev-tree",
    category: "development",
  },
  {
    name: "Discava! (Discogs API)",
    link: "http://dev.juanfalibene.com/discava/index.html",
    category: "development",
  },
  {
    name: "©Juan Falibene 2026",
    category: "credit",
  },
  {
    name: "Barcelona",
    category: "credit",
  },
];

// Certificates
export const certificates_es = [
  {
    name: "Desenvolupament web Front End CIFO L'Hospitalet",
    link: "https://juanfalibene.com/resume/downloads/Certificat-417219-Y8901768T.PDF",
    year: 2023,
  },
  {
    name: "SEO, SEM i analítica Web",
    link: "https://juanfalibene.com/resume/downloads/16_ca355c68-8cdf-4f34-b3a4-8c8c0aadb87b_f2150287-6a9e-44e7-afd7-3ecc90493f73.pdf",
    year: 2025,
  },
  {
    name: "Backend & Automation: Python, Flask, Django",
    link: "https://juanfalibene.com/resume/downloads/diploma.pdf",
    year: 2025,
  },
  {
    name: "English Reading(C2) & Listening(B2) EF SET",
    link: "https://juanfalibene.com/resume/downloads/EF_SET_Certificate.pdf",
    year: 2024,
  },
  {
    name: "CSS: Diseño web responsive",
    link: "https://juanfalibene.com/resume/downloads/1673896108444.png",
    year: 2023,
  },
  {
    name: "Diseño de interfaz (UI)",
    link: "https://juanfalibene.com/resume/downloads/1673478097062.png",
    year: 2023,
  },
  {
    name: "Experiencia de usuario (UX)",
    link: "https://juanfalibene.com/resume/downloads/1673444494312.png",
    year: 2023,
  },
];

// Resume
export const resume_urls_es = [
  {
    name: "Currículum ESP PDF",
    link: "https://juanfalibene.com/resume/downloads/Juan_Ignacio_Falibene_CV_2026.pdf",
    action: "Descargar",
  },
  {
    name: "Currículum ENG PDF",
    link: "https://juanfalibene.com/resume/downloads/Juan_Ignacio_Falibene_CV_EN_2025.pdf",
    action: "Descargar",
  },
  {
    name: "Currículum Online",
    link: "https://juanfalibene.com/resume/index.html",
    action: "Ver",
  },
];
